

































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import Datepicker from 'vuejs-datepicker';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
const UserRepository = RepositoryFactory.get('user');

@Component({
  components: {
    Datepicker
  },
  computed: {
    validationErrors(): any {
      return this.$store.state.question.errorMessages;
    }
  }
})
export default class ConsentForm extends Vue {
  DatePickerFormat = 'yyyy-MM-dd';
  checked = '';
  full_name = '';
  full_name_kana = '';
  date_of_birth = new Date('1990-01-01');
  sex = '';
  phone = '';
  email = '';
  zip_code = '';
  errors = '';
  is_valid: boolean | null = null;

  async consentForm(): Promise<any> {
    this.toggleLoading({ is_loading: true, time: 0 });
    if (!this.checked) {
      this.$toasted.error('個人情報の取り扱いに同意されていません', {
        duration: 2000,
        position: 'top-center'
      });
      this.toggleLoading({ is_loading: false, time: 0 });
      return;
    }
    const date =
      this.date_of_birth.getFullYear() +
      '-' +
      String(this.date_of_birth.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(this.date_of_birth.getDate()).padStart(2, '0');
    const response = await UserRepository.saveData({
      full_name: this.full_name,
      full_name_kana: this.full_name_kana,
      date_of_birth: date,
      sex: this.sex,
      phone: this.phone,
      zip_code: this.zip_code
    });
    this.errors = '';
    if (!response) {
      this.$toasted.error('ネットワークに問題があります', {
        duration: 2000,
        position: 'top-center'
      });
      this.toggleLoading({ is_loading: false, time: 0 });
    } else if ('timeout' in response && response.timeout == true) {
      this.$toasted.error('タイムアウトが発生しました', {
        duration: 2000,
        position: 'top-center'
      });
      this.toggleLoading({ is_loading: false, time: 0 });
    } else if (response.status == 500) {
      this.$toasted.error('処理に失敗しました', {
        duration: 2000,
        position: 'top-center'
      });
      this.is_valid = false;
      this.toggleLoading({ is_loading: false, time: 0 });
    } else if (response.status == 422) {
      this.$toasted.error('入力項目に間違いがあります', {
        duration: 2000,
        position: 'top-center'
      });
      this.is_valid = false;
      this.errors = response.data.errors;
      this.$store.commit('setErrorMessages', response.data.errors);
      this.toggleLoading({ is_loading: false, time: 0 });
    } else if (response.status == 401) {
      this.$toasted.error('ログアウトされています', {
        duration: 2000,
        position: 'top-center'
      });
      this.$store.commit('setUser', null);
      this.$store.commit('setRemember', false);
      this.$store.commit('setLimit', 0);
      this.$store.commit('setApiToken', null);
      this.$store.commit('answer/setAnswers', {});
      this.$router.push('/auth/login');
    } else if (response.status == 200 && response.data.status == 'success') {
      this.$router.push('/base');
    }
    return;
  }

  // Loadingの表示，非表示の制御
  toggleLoading(params: { is_loading: boolean; time: number }): void {
    this.$emit('toggleLoading', params);
  }

  async mounted(): Promise<any> {
    this.toggleLoading({ is_loading: true, time: 0 });

    const user = await this.$store.state.user;
    this.email = user.user.email;
    window.scrollTo(0, 0);
    this.toggleLoading({ is_loading: false, time: 0 });
  }
}
